import React, { useState } from "react";
import folder from "./assets/folder.png";
import document from './assets/document.png'
import "./styles/desktop.css";
import OpenWindow from "./OpenWindow";
import Dock from "./Dock";
import {desktopContext} from "./context/desktopContext"


const Desktop = () => {


  const [windowOpen, setWindowOpen] = useState(false)
  const [openWindowTitle, setOpenWindowTitle] = useState('')
  const [app, setApp] = useState('')

  const folderClickHandler = (title) => {
    setWindowOpen(true)
    setOpenWindowTitle(title)
    setApp('Filemanager')
  }

  const docClickHandler = (title) =>{
    setWindowOpen(true)
    setOpenWindowTitle(title)
    setApp(title)  
  }


  const cntxt = {
    'windowOpen'          : windowOpen,
    'setWindowOpen'       : setWindowOpen,
    'openWindowTitle'     : openWindowTitle,
    'setOpenWindowTitle'  : setOpenWindowTitle,
    'app'                 : app,
    'setApp'              : setApp,
  }

  return (
    <>
      <div className="background-image-container" >
        <div className="folder-with-text">
          <img className="folder" src={folder} alt = 'Good Game Easy' onClick = {() => folderClickHandler("Projects")}/>
          <p>Projects</p>
        </div>


        <div className="folder-with-text">
          <img className="folder" src={document} alt = 'Good Game Easy' onClick = {() => docClickHandler("Skills")}/>
          <p>Skills</p>
        </div>

        <div className="folder-with-text">
          <img className="folder" src={document} alt = 'Good Game Easy' onClick = {() => docClickHandler("Resume")}/>
          <p>Resume</p>
        </div>

        <div className="folder-with-text">
          <img className="folder" src={document} alt = 'Good Game Easy' onClick = {() => docClickHandler("About Me")}/>
          <p>AboutMe</p>
        </div>

        <div className="folder-with-text">
          <img className="folder" src={document} alt = 'Good Game Easy' onClick = {() => docClickHandler("Work Experience")}/>
          <p>WorkExp</p>
        </div>
      <desktopContext.Provider value = {cntxt}>

      <Dock/>
      {windowOpen && <OpenWindow/> }
      </desktopContext.Provider>

      </div>


    </>
  );
};

export default Desktop;
